export const MODEL_FILES = [
  { name: "academico.csv", type: "Acadêmico" },
  { name: "adesao.csv", type: "Adesão" },
  { name: "aluno.csv", type: "Alunos" },
  { name: "captacao.csv", type: "Captação" },
  { name: "docente.csv", type: "Docentes" },
  { name: "faturamento.csv", type: "Faturamento" },
  { name: "historico_status.xlsx", type: "Histórico de Status" },
  { name: "turma.csv", type: "Turmas" }
];

export const downloadModelFiles = () => {
  MODEL_FILES.forEach((file) => {
    const link = document.createElement("a");
    link.href = `/model-files/${file.name}`;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
};
